/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class ReadEntry {
    userId;
    conversation;
    readTime;
}
